<template>
  <div class="testimonials-item">
    <header>
      <div class="testimonials-item__icon">
        <component :is="icon"></component>
      </div>
      <rwl-heading h="4" class="testimonials-item__title" align="center" v-html="title"></rwl-heading>
    </header>
    <div class="testimonials-item__description" v-html="description">
    </div>
  </div>
</template>

<script>
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library"

  export default {
    name: "TestimonialsItem",
    props: {
      description: {
        type: String,
        default: "",
      },
      title: {
        type: String,
        default: ""
      },
      icon: {}
    },
    components: { RwlHeading }
  }
</script>

<style lang="scss" scoped>
  .testimonials-item {
    margin: $spacing-4 0 $spacing-6;
    display: flex;
    flex-direction: column;

    header {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      height: 110px;
      padding: 0 $spacing-5;
    }

    &__title {
      font-size: 20px !important;
      font-weight: 500 !important;
      text-align: center;
      color: #036;
    }

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__description {
      text-align: left;
      min-height: 90px;
      padding: 0 0 $spacing-5;
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
</style>
